import React, { useContext, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { FaEdit, FaPlus, FaTimes, FaTrash } from 'react-icons/fa';
import Loader from '../Loader/Loader';


const Modal = ({ isModalOpen, setIsModalOpen, foreignDenominationItem, setForeignDenominationItem, handleSubmitForeignDenomination }) => {
    //   // Only render the modal if isOpen is true
    if (!isModalOpen) return null;

    return (
        <>
            {/* Modal Overlay */}
            <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center z-50">
                {/* Modal Content */}
                <div className="bg-white rounded-lg w-full sm:w-96 p-6 mx-4 sm:mx-auto shadow-lg relative">
                    {/* Close Icon at top-right corner */}
                    <button
                        onClick={() => setIsModalOpen(val => !val)}
                        className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 focus:outline-none"
                    >
                        <FaTimes className="text-2xl" />
                    </button>

                    <h1 className="text-2xl font-semibold text-gray-800 mb-4"><span className='text-lg font-thin'>Currency :</span>&nbsp;&nbsp;{foreignDenominationItem.currency}</h1>
                    {/* <h2 className="text-xl font-medium text-gray-600 mb-4"><span className='text-lg font-thin'>Currency :</span>&nbsp;&nbsp;{denominationItem.country}</h2> */}

                    <form onSubmit={handleSubmitForeignDenomination}>
                        <div className="mb-4">
                            <label htmlFor="inputField" className="block text-lg text-gray-700 mb-2">Denomination Value </label>
                            <input
                                onChange={(e) => setForeignDenominationItem({
                                    ...foreignDenominationItem, denomination: e.target.value
                                })}
                                type="text"
                                id="inputField"
                                defaultValue={foreignDenominationItem.denomination}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-700 focus:ring-2 focus:ring-blue-600 focus:outline-none"
                                placeholder="Enter Denomination Value"
                            />
                        </div>

                        {/* Submit Button at the bottom */}
                        <div className="flex justify-end">
                            <button
                                type="submit"
                                className="px-6 py-2 bg-blue-600 text-white rounded-md font-semibold hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-600 transition-all"
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

function UpdateCurrencyRates() {
    const [activeSection, setActiveSection] = useState('uploadCurrencyRates'); // Keeps track of which section is active
    const [file, setFile] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [localBalance, setLocalBalance] = useState(null);
    const [currencyRates, setCurrencyRates] = useState([]);
    const [foreignCurrency, setForeignCurrency] = useState('')
    const [foreignCountry, setForeignCountry] = useState('')
    const [foreignBalance, setForeignBalance] = useState('');
    const [foreignDenomination, setForeignDenomination] = useState([]);
    const [foreignDenominationCurrency, setForeignDenominationCurrency] = useState('');
    const [foreignDenominationCountry, setForeignDenominationCountry] = useState('');
    const [foreignDenominationItem, setForeignDenominationItem] = useState({})
    const [errorMessage, setErrorMessage] = useState('');
    const [existingShops, setExistingShops] = useState([]);
    const [shop, setShop] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    // const formRefLocal = useRef(null);
    const formRefForeign = useRef(null);
    const formRefUploadRates = useRef(null);

    const navigate = useNavigate()

    // user token for API request
    const token = JSON.parse(window.localStorage.getItem("auth"))?.token;

    // userDatail  for API request
    const userDetail = JSON.parse(window.localStorage.getItem("auth"))?.user;

    useEffect(() => {
        if (userDetail && userDetail.userRole !== 'Admin') {
            navigate('/shopSelection');
        }
    }, [])

    useEffect(() => {
        if (userDetail && userDetail.userRole === 'Admin' && userDetail.shopId === undefined) {
            navigate('/shopSelection');
        }
    }, [])

    useEffect(() => {
        const fetchShops = async () => {
            try {
                const response = await axios.get(process.env.REACT_APP_API_URL + `getShops`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                const shops = response.data;
                // rates.AUD = 1;
                setExistingShops(shops);

            } catch (error) {
                console.log(error);
            }
        };
        fetchShops();
    }, [])

    useEffect(() => {
        if (userDetail && userDetail.shopId === undefined) return;

        const fetchCurrencyRates = async () => {
            try {

                const response = await axios.get(process.env.REACT_APP_API_URL + `getCurrencyRates`, {
                    params: {
                        shopId: userDetail?.shopId
                    },
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                const rates = response.data;
                setCurrencyRates(rates);


            } catch (error) {
                toast.error('Error.');
            }
        };
        fetchCurrencyRates();
    }, [])

    useEffect(() => {
        if (userDetail && userDetail.shopId === undefined) return;

        const fetchLocalBalance = async () => {
            try {

                // setShop(val => shopId)

                const response = await axios.get(process.env.REACT_APP_API_URL + 'getLocalBalance', {
                    params: {
                        shopId: userDetail?.shopId
                    },
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                if (response.data) {
                    const totalBalance = response.data.totalAmount;
                    const balanceInput = document.getElementById('localBalanceInput');
                    if (balanceInput) {
                        balanceInput.textContent = totalBalance; // Update the content of the element
                    }
                    setLocalBalance(val => totalBalance)
                }
            } catch (error) {
                toast.error('Error.');
            }
        };
        fetchLocalBalance();
    }, [])

    // Function to upload currency rates
    const handleSubmit = async (event) => {
        event.preventDefault();

        // if (!file || !shop) {
        //     toast.error('Please Fill All the Fields')
        //     return
        // }

        const formData = new FormData();
        formData.append("file", file);
        formData.append("shopId", userDetail && userDetail.shopId);

        try {
            setIsLoading(true)
            // Simulate upload progress
            const uploadInterval = setInterval(() => {
                setUploadProgress((prevProgress) => Math.min(prevProgress + 10, 100));
            }, 500);

            const response = await axios.post(process.env.REACT_APP_API_URL + 'uploadCurrencyRates', formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                onUploadProgress: (progressEvent) => {
                    setUploadProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                },
            });

            clearInterval(uploadInterval);

            const data = await response.data;
            if (data.success) {
                setUploadProgress(0);
                setErrorMessage('');
                toast.success('Currency Rates Updated Successfully.');
                formRefUploadRates.current.reset();
                setFile(null);
                setShop('');
            } else {
                setErrorMessage(data.error);
                toast.error('Error: Currency Rates not Updated.');
                setFile(null);
                setShop('');
            }
            setIsLoading(false)
        } catch (error) {
            setUploadProgress(0);
            setErrorMessage('An error occurred during upload.');
            toast.error('Error: Currency Rates not Updated.');
            setFile(null);
            setShop('');
            setIsLoading(false)
        }
    };

    const handleSubmitLocalBalance = async (e) => {
        e.preventDefault();

        try {
            setIsLoading(true)
            const response = await axios.post(process.env.REACT_APP_API_URL + 'localBalanceUpdate', { localBalance, shopId: userDetail?.shopId }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.status === 201) toast.success('Local Currency Balance Updated Successfully.');
            // formRefLocal.current.reset();
            setShop('');
            setLocalBalance('');
            setIsLoading(false)
        } catch (error) {
            toast.error('Error: Currency Rates not Updated.');
            setIsLoading(false)
        }
    }

    const handleChangeForeignCurrencyBalance = async (currency) => {

        // if (!shop) {
        //     toast.error('Please select the Shop First');
        //     return
        // }
        const currencyArray = currency.split(', ');

        setForeignCurrency(currencyArray[0]);
        setForeignCountry(currencyArray[1]);
        try {
            setIsLoading(true)
            const response = await axios.post(process.env.REACT_APP_API_URL + 'getForeignBalance', { foreignCurrency: currencyArray[0], shopId: userDetail?.shopId }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.data && response.status === 201) {

                const balance = response.data.totalAmount
                setForeignBalance(balance);
            } else {
                setForeignBalance('')
            }
            setIsLoading(false)

        } catch (error) {
            toast.error('Error: Currency Rates not Updated.');
            setIsLoading(false)
        }

    }

    const handleSubmitForeignBalance = async (e) => {
        e.preventDefault();

        // if (!shop || !foreignCurrency || !foreignCountry || !foreignBalance) {
        //     toast.error('Please Fill All the Fields');
        //     return;
        // }

        try {
            setIsLoading(true)
            const response = await axios.post(process.env.REACT_APP_API_URL + 'foreignBalanceUpdate', { shopId: userDetail?.shopId, foreignCurrency, foreignCountry, foreignBalance }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.status === 201) toast.success('Foreign Currency Balance Updated Successfully.');
            formRefForeign.current.reset();
            setShop('');
            setForeignCurrency('');
            setForeignCountry('');
            setForeignBalance('');
            setIsLoading(false)
        } catch (error) {
            toast.error('Error: Currency Rates not Updated.');
            setIsLoading(false)
        }
    }

    const handleChangeForeignDenomination = async (currency) => {
        const currencyArray = currency.split(', ');

        setForeignDenominationCurrency(currencyArray[0]);
        setForeignDenominationCountry(currencyArray[1]);
        try {
            setIsLoading(true)
            const response = await axios.post(process.env.REACT_APP_API_URL + 'getForeignCurrencyDenominations', { shopId: userDetail?.shopId, foreignCurrency: currencyArray[0] }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.data && response.status === 201) {

                console.log('response.data', response.data)
                setForeignDenomination(response.data);
            } else {
                setForeignDenomination('')
            }
            setIsLoading(false)

        } catch (error) {
            toast.error('Error: Denominations not Fetched Successfully.');
            setIsLoading(false)
        }
    }

    const handleAddForeignDenomination = () => {
        setForeignDenominationItem({
            ...foreignDenominationItem, currency: foreignDenominationCurrency, shopId: userDetail?.shopId
        })
        setIsModalOpen(val => !val)
    }

    const handleSubmitForeignDenomination = async (e) => {
        e.preventDefault();
        try {
            setIsLoading(true)
            const response = await axios.post(process.env.REACT_APP_API_URL + 'addDenomination', foreignDenominationItem, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.status === 200) {
                setIsModalOpen(val => !val)
                toast.success('Denomination Created Successfully.');
                const currency = `${foreignDenominationCurrency}, ${foreignDenominationCountry}`
                await handleChangeForeignDenomination(currency);
                setForeignDenominationItem({});
                // setDenominationCurrency('');
                // setDenominationCountry('');

            }
            setIsLoading(false)

        } catch (error) {
            toast.error('Error: Denomination Not Created.');
            setIsLoading(false)
        }
    }

    const handleDeleteForeignDenomination = async (item) => {
        try {
            setIsLoading(true)
            const response = await axios.post(process.env.REACT_APP_API_URL + 'deleteForeignDenomination', item, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.status === 200) {
                // setIsModalOpen(val => !val)
                toast.success('Denomination Deleted Successfully.');
                const currency = `${foreignDenominationCurrency}, ${foreignDenominationCountry}`
                await handleChangeForeignDenomination(currency);
                // setForeignDenominationItem({});
                // setDenominationCurrency('');
                // setDenominationCountry('');

            }
            setIsLoading(false)

        } catch (error) {
            toast.error('Error: Denomination Not Deleted.');
            setIsLoading(false)
        }
    }




    return (
        <div className="container mx-auto p-5 space-y-10 flex flex-col">
            {/* Left Sidebar with Buttons */}
            <div className="w-full    ml-[0px] mt-[-35px]">
                {/* <h2 className="text-xl font-semibold text-gray-800 mb-6">Settings</h2> */}
                <div className="flex  justify-between">
                    <button
                        onClick={() => setActiveSection('uploadCurrencyRates')}
                        className={`w-[500px] h-10 py-1 px-2  text-md font-medium border-x-2  ${activeSection === 'uploadCurrencyRates' ? 'bg-[#053F7D] text-white' : 'bg-gray-300'}`}
                    >
                        Upload Currency Rates
                    </button>
                    <button
                        onClick={() => setActiveSection('uploadLocalBalance')}
                        className={`w-[500px] h-10 py-1  px-2 text-md font-medium border-x-2 ${activeSection === 'uploadLocalBalance' ? 'bg-[#053F7D] text-white' : 'bg-gray-300'}`}
                    >
                        Upload Local Balance
                    </button>
                    <button
                        onClick={() => setActiveSection('uploadForeignBalance')}
                        className={`w-[500px] h-10  py-1 px-2 text-md font-medium border-x-2 ${activeSection === 'uploadForeignBalance' ? 'bg-[#053F7D] text-white' : 'bg-gray-300'}`}
                    >
                        Upload Foreign Balance
                    </button>
                    {/* <button
                        onClick={() => setActiveSection('uploadLocalDenomination')}
                        className={`w-[500px] h-10  py-1 px-2 text-md font-medium border-x-2 ${activeSection === 'uploadLocalDenomination' ? 'bg-[#053F7D] text-white' : 'bg-gray-300'}`}
                    >
                        Upload Local Denomination
                    </button> */}
                    <button
                        onClick={() => setActiveSection('uploadForeignDenomination')}
                        className={`w-[500px] h-10  py-1 px-2 text-md font-medium border-x-2 ${activeSection === 'uploadForeignDenomination' ? 'bg-[#053F7D] text-white' : 'bg-gray-300'}`}
                    >
                        Upload Foreign Denomination
                    </button>

                </div>
            </div>

            {isLoading ? <Loader /> : ''}
            {/* Right Content Area */}
            <div className="w-[400px] ml-[400px] bg-white pt-[100px] rounded-lg p-6">

                {/* Conditional rendering based on the selected action */}
                {activeSection === 'uploadLocalBalance' && (
                    <div className='mt-[-50px]'>
                        <h3 className="text-xl font-semibold text-gray-800 text-center mb-4">Upload Local Balance</h3>

                        <form onSubmit={handleSubmitLocalBalance}>

                            {/* Shop Selection */}
                            {/* <div className="mb-5">
                                <select
                                    // onChange={(e) => handleChangeLocalBalanceShop(e.target.value)}
                                    className="w-full px-4 py-2 bg-gray-50 border border-gray-300 rounded-lg text-gray-800 focus:ring-2 focus:ring-blue-600"
                                >
                                    <option>Select Shop</option>
                                    {existingShops.map((shop, index) => (
                                        <option key={index} value={shop._id}>{shop.name}</option>
                                    ))}
                                </select>
                            </div> */}

                            {/* Balance Input */}
                            <div className={`mb-4 `}>
                                <label htmlFor="localBalance" className="block text-lg text-gray-700">Balance</label>
                                <input
                                    id='localBalanceInput'
                                    type="text"
                                    defaultValue={localBalance}
                                    onChange={(e) => setLocalBalance(e.target.value)}
                                    placeholder="Enter Local balance"
                                    className="w-full px-4 py-2 bg-gray-50 border border-gray-300 rounded-lg text-gray-800 focus:ring-2 focus:ring-blue-600"
                                />
                            </div>

                            {/* Submit Button */}
                            <button
                                type='submit'
                                className={`w-full px-6 py-2 text-white font-medium rounded-md focus:outline-none transition-all ${localBalance ? 'bg-gradient-to-br from-blue-500 to-blue-900 hover:bg-gradient-to-bl' : 'bg-gray-400 cursor-not-allowed'}`}
                                disabled={!localBalance} // Disable button if shop or localBalance is not set
                            >
                                Submit
                            </button>

                        </form>
                    </div>
                )}

                {activeSection === 'uploadForeignBalance' && (
                    <div className='mt-[-50px]'>
                        <h3 className="text-xl font-semibold text-gray-800 text-center mb-4">Upload Foreign Balance</h3>
                        <form ref={formRefForeign} onSubmit={handleSubmitForeignBalance}>
                            {/* <div className="mb-4">
                                <select
                                    // onChange={(e) => handleChangeForeignBalanceShop(e.target.value)}
                                    className="w-full px-4 py-2 bg-gray-50 border border-gray-300 rounded-lg text-gray-800 focus:ring-2 focus:ring-blue-600"
                                >
                                    <option>Select Shop</option>
                                    {existingShops.map((shop, index) => (
                                        <option key={index} value={shop._id}>{shop.name}</option>
                                    ))}
                                </select>
                            </div> */}

                            <div className='mb-4 '>
                                {/* <label htmlFor="localBalance" className="block text-base text-gray-700 mb-1">Select Currency: </label> */}
                                <select onChange={(e) => handleChangeForeignCurrencyBalance(e.target.value)} className="w-full px-4 py-2 bg-gray-50 border border-gray-300 rounded-lg text-gray-800 focus:ring-2 focus:ring-blue-600">
                                    <option >Select Currency</option>
                                    {currencyRates && currencyRates.map((val, index) => (
                                        <option key={index}>{val.currency}, {val.country}</option>
                                    ))}
                                </select>
                            </div>
                            <div className={`mb-4 flex flex-col  `}>
                                <label htmlFor="localBalance" className="block text-base text-gray-700 mb-1">Balance</label>
                                <input type="text" defaultValue={foreignBalance} onChange={(e) => setForeignBalance(e.target.value)} className=" px-4 py-2 bg-gray-50 border border-gray-300 rounded-lg text-gray-800 focus:ring-2 focus:ring-blue-600" placeholder="Enter foreign balance" />
                            </div>

                            <button type='submit' className={`w-full px-6 py-2 text-white font-medium rounded-md focus:outline-none transition-all ${foreignBalance ? 'bg-gradient-to-br from-blue-500 to-blue-900 hover:bg-gradient-to-bl' : 'bg-gray-400 cursor-not-allowed'} `} disabled={!foreignBalance} > Submit Balance</button>
                        </form>
                    </div>
                )}

                {/* {activeSection === 'uploadLocalDenomination' && ( */}
                {/* <div className='mt-[-50px]'> */}
                {/* <h3 className="text-xl font-semibold text-gray-800 text-center mb-4">Upload Denomination</h3> */}
                {/* <form> */}
                {/* <div className="mb-4"> */}
                {/* <select defaultValue={foreignCurrency} onChange={(e) => handleChangeForeignDenomination(e.target.value)} className='w-full text-left'> */}
                {/* <option>Select Balance Type</option> */}
                {/* <option >, Safe</option> */}
                {/* <option >, Notes</option> */}
                {/* <option >, BulkCoins</option> */}
                {/* <option >, Coins In Tray</option> */}
                {/* </select> */}
                {/* </div> */}
                {/* <div className='w-full mb-4'> */}
                {/* <h3 className="text-xl font-semibold text-gray-800 text-center mb-4">Denominations</h3> */}
                {/* <div className='grid grid-cols-3 gap-4'> */}
                {/* Dynamic button generation */}
                {/* {foreignDenomination && foreignDenomination.map((item, index) => ( // Example: Array with 6 items for demonstration */}
                {/* <div key={index} className="relative w-[110px] h-[50px] bg-[#053E7C] text-white font-semibold rounded-md flex items-center justify-center"> */}
                {/* <span className='text-xl font-thin'>{item.denomination}</span> Display the denomination */}
                {/* <button type='button' onClick={() => handleExistingDenomination(item)}><FaEdit className="absolute top-1 left-1 text-green-500 text-lg cursor-pointer" /></button> */}
                {/* <button type='button' onClick={() => setIsModalOpen(val => !val)}><FaTrash className="absolute top-1 right-1 text-red-500 text-lg font-thin cursor-pointer" /></button> */}
                {/* </div> */}
                {/* ))} */}

                {/* Add button at the end with plus sign */}
                {/* <button type='button' onClick={() => handleAddForeignDenomination()} className={`relative w-[110px] h-[50px] bg-[#053E7C] text-white font-semibold rounded-md flex items-center justify-center ${foreignDenominationCurrency || foreignDenominationCountry ? '' : 'hidden'}`}> */}
                {/* <span className='text-xl font-thin'>Add</span> Display Add text */}
                {/* <FaPlus className="absolute top-1 left-1 text-green-300 text-lg cursor-pointer" /> Plus sign icon */}
                {/* </button> */}
                {/* </div> */}
                {/* </div> */}
                {/* <div className="mb-4 hidden "> */}
                {/* <label htmlFor="foreignBalance" className="block text-lg text-gray-700">Balance</label> */}
                {/* <input type="text" defaultValue={foreignBalance} onChange={(e) => setForeignBalance(e.target.value)} className="w-full px-4 py-2 bg-gray-50 border border-gray-300 rounded-lg text-gray-800 focus:ring-2 focus:ring-blue-600" placeholder="Enter foreign balance" /> */}
                {/* </div> */}
                {/* <button type="submit" className={`w-full hidden px-6 py-2 text-white font-medium rounded-md focus:outline-none transition-all ${foreignBalance ? 'bg-gradient-to-br from-blue-500 to-blue-900 hover:bg-gradient-to-bl' : 'bg-gray-400 cursor-not-allowed'}`} > */}
                {/* Submit */}
                {/* </button> */}
                {/* </form> */}
                {/* <Modal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} foreignDenominationItem={foreignDenominationItem} setForeignDenominationItem={setForeignDenominationItem} handleSubmitForeignDenomination={handleSubmitForeignDenomination} foreignDenominationCurrency={foreignDenominationCurrency} /> */}
                {/* </div> */}
                {/* )} */}

                {activeSection === 'uploadForeignDenomination' && (
                    <div className='mt-[-50px]'>
                        {/* <h3 className="text-xl font-semibold text-gray-800 text-center mb-4">Upload Denomination</h3> */}
                        <form>
                            {/* <div className=" flex flex-col mb-6">
                                <label htmlFor="foreignDenomination" className="block text-lg text-gray-700 mb-1">Select Shop: </label>
                                <select
                                    onChange={(e) => handleChangeForeignBalanceShop(e.target.value)}
                                    className="w-full px-4 py-2 bg-gray-50 border border-gray-300 rounded-lg text-gray-800 focus:ring-2 focus:ring-blue-600"
                                >
                                    <option>Select Shop</option>
                                    {existingShops.map((shop, index) => (
                                        <option key={index} value={shop._id}>{shop.name}</option>
                                    ))}
                                </select>
                            </div> */}
                            <div className="flex flex-col mb-4">
                                <label htmlFor="foreignDenominationCurrency" className="block text-lg text-gray-700 mb-1">Select Currency: </label>
                                <select defaultValue={foreignCurrency} onChange={(e) => handleChangeForeignDenomination(e.target.value)} className='w-full px-4 py-2 bg-gray-50 border border-gray-300 rounded-lg text-gray-800 focus:ring-2 focus:ring-blue-600'>
                                    <option>Select Currency</option>
                                    {currencyRates && currencyRates.map((val, index) => (
                                        <option key={index}>{val.currency}, {val.country}</option>
                                    ))}
                                </select>
                            </div>
                            <div className={`w-full mb-4 ${foreignDenomination ? '' : 'hidden'} `}>
                                <h3 className={`text-xl font-semibold text-gray-800 text-center mb-4 `}>Denominations</h3>
                                <div className='grid grid-cols-3 gap-4'>
                                    {/* Dynamic button generation */}
                                    {foreignDenomination && foreignDenomination.map((item, index) => ( // Example: Array with 6 items for demonstration
                                        <div key={index} className="relative w-[110px] h-[50px] bg-[#053E7C] text-white font-semibold rounded-md flex items-center justify-center">
                                            <span className='text-xl font-thin'>{item.denomination}</span> {/* Display the denomination */}
                                            {/* <button type='button' onClick={() => handleExistingDenomination(item)}><FaEdit className="absolute top-1 left-1 text-green-500 text-lg cursor-pointer" /></button> */}
                                            <button type='button' onClick={() => handleDeleteForeignDenomination(item)}><FaTrash className="absolute top-1 right-1 text-red-500 text-lg font-thin cursor-pointer" /></button>
                                        </div>
                                    ))}

                                    {/* Add button at the end with plus sign */}
                                    <button type='button' onClick={() => handleAddForeignDenomination()} className={`relative w-[110px] h-[50px] bg-[#053E7C] text-white font-semibold rounded-md flex items-center justify-center ${foreignDenominationCurrency || foreignDenominationCountry ? '' : 'hidden'}`}>
                                        <span className='text-xl font-thin'>Add</span> {/* Display Add text */}
                                        <FaPlus className="absolute top-1 left-1 text-green-300 text-lg cursor-pointer" /> {/* Plus sign icon */}
                                    </button>
                                </div>
                            </div>
                            <div className="mb-4 hidden ">
                                <label htmlFor="foreignBalance" className="block text-lg text-gray-700">Balance</label>
                                <input type="text" defaultValue={foreignBalance} onChange={(e) => setForeignBalance(e.target.value)} className="w-full px-4 py-2 bg-gray-50 border border-gray-300 rounded-lg text-gray-800 focus:ring-2 focus:ring-blue-600" placeholder="Enter foreign balance" />
                            </div>
                            <button type="submit" className={`w-full hidden px-6 py-2 text-white font-medium rounded-md focus:outline-none transition-all ${foreignBalance ? 'bg-gradient-to-br from-blue-500 to-blue-900 hover:bg-gradient-to-bl' : 'bg-gray-400 cursor-not-allowed'}`} >
                                Submit
                            </button>
                        </form>
                        <Modal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} foreignDenominationItem={foreignDenominationItem} setForeignDenominationItem={setForeignDenominationItem} handleSubmitForeignDenomination={handleSubmitForeignDenomination} foreignDenominationCurrency={foreignDenominationCurrency} />
                    </div>
                )}

                {activeSection === 'uploadCurrencyRates' && (
                    <div className='mt-[-50px]'>
                        <h3 className="text-xl font-semibold text-gray-800 text-center mb-5">Upload Currency Rates</h3>
                        <form ref={formRefUploadRates} onSubmit={handleSubmit}>
                            {/* <div className="mb-5">
                                <select
                                    onChange={(e) => setShop(e.target.value)}
                                    className="w-full px-4 py-2 bg-gray-50 border border-gray-300 rounded-lg text-gray-800 focus:ring-2 focus:ring-blue-600"
                                >
                                    <option  className='text-gray-300'>Select Shop</option>
                                    {existingShops && existingShops.map((shop, index) => (
                                        <option key={index} value={shop._id}>{shop.name}</option>
                                    ))}
                                </select>
                            </div> */}
                            <div className="mb-5">
                                <input
                                    type="file"
                                    accept=".xlsx,.xlsm"
                                    onChange={(e) => setFile(e.target.files[0])}
                                    className="w-full px-4 py-2 bg-gray-50 border border-gray-300 rounded-lg text-gray-800 focus:ring-2 focus:ring-blue-600"
                                />
                            </div>
                            {file && (
                                <p className="text-sm text-gray-600 text-center mt-2">{file.name}</p>
                            )}
                            <div className="flex justify-center mt-4">
                                <button
                                    type="submit"
                                    className={`w-full px-6 py-3 text-white font-medium rounded-md focus:outline-none transition-all ${uploadProgress > 0 ? 'bg-gray-400 cursor-not-allowed' : 'bg-gradient-to-br from-blue-500 to-blue-900 hover:bg-gradient-to-bl'}`}
                                    disabled={uploadProgress > 0 || !file}
                                >
                                    {uploadProgress > 0 ? `Uploading... ${uploadProgress}%` : 'Upload'}
                                </button>
                            </div>
                            {uploadProgress > 0 && (
                                <div className="mt-4">
                                    <div className="relative pt-1">
                                        <div className="flex mb-2 items-center justify-between">
                                            <div>
                                                <span className="text-xs font-semibold inline-block py-1 uppercase">Upload Progress</span>
                                            </div>
                                            <div>
                                                <span className="text-xs font-semibold inline-block py-1">{uploadProgress}%</span>
                                            </div>
                                        </div>
                                        <div className="flex mb-2">
                                            <div className="w-full bg-gray-200 rounded-full">
                                                <div
                                                    className="bg-gradient-to-br from-blue-500 to-green-500 text-xs font-medium text-center p-0.5 leading-none rounded-full"
                                                    style={{ width: `${uploadProgress}%` }}
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {errorMessage && <p className="text-red-500 text-center text-sm">{errorMessage}</p>}
                        </form>
                    </div>
                )}
            </div>
        </div>
    );
}

export default UpdateCurrencyRates;

